import { render, staticRenderFns } from "./ClimateAction.vue?vue&type=template&id=12b5ff6c&"
import script from "./ClimateAction.vue?vue&type=script&lang=ts&"
export * from "./ClimateAction.vue?vue&type=script&lang=ts&"
import style0 from "./ClimateAction.vue?vue&type=style&index=0&id=12b5ff6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports